import { Row, Col, Input, Button, Table, List, message, Card, DatePicker, Popconfirm} from "antd"
import { useState, useEffect } from 'react'

import SelectProject from '../components/selectProject'
import SelectStatus from '../components/selectStatus'
import ModReturn from '../components/modReturn'
import DialPhone from '../components/dialPhone'

import req from '../request'

const App = props => {
    const [ returns, setReturns ] = useState([])
    const [ filters, setFilters ] = useState({})
    const [ pagi,setPagi ] = useState({pageSize:30,total:0,field:'id'})
    const [ loading,setLoading ] = useState(false)
    const [ phones, setPhones ] = useState(null)
    const [selectedRowKeys, setSelectedRowKeys ] = useState([])
    const subReturns = () => {
        setLoading(true)
        const dt = { action: 'subReturns', ...filters, phones:phones }
        // console.log(dt);
        req.post('/api/return',dt).then(r=>{
            // setLoading(false)
            console.log(r)
            if(r.status==='done'){
                message.success('提交成功')
                getReturns()
            }else{
                message.error(r.msg)
            }
        })
    }

    const getReturns = () => {
        setLoading(true)
        const dt = {action:'getReturns',...filters}
        dt.field = pagi.field
        dt.order = pagi.order
        dt.page = pagi.current
        console.log(dt);
        req.post('/api/return', dt).then(r => {
            console.log(r)
            setLoading(false)
            if(r.status === 'done'){
                setReturns(r.datas)
                const _pagi = { ...pagi }
                _pagi.current = r.current
                _pagi.total = r.total
                setPagi(_pagi)
            }else{
                message.error(r.msg)
            }
 
        })
    }

    const handleRange = (_,r) => {
        const _filters = {...filters}
        _filters.range = r
        setFilters(_filters)
    }

    const title = () => <>
        <h3>退回数据</h3>
        <Row style={{paddingBottom:'10px'}} gutter={5}>
            <Col>
                <SelectProject value={filters.pid} onChange={t => {
                    const _filters = { ...filters }
                    _filters.pid = t
                    setFilters(_filters)
                }} />
            </Col>
        </Row>
        
        <Row>
            <Col>
                <Input.TextArea onChange={e=>{
                    setPhones(e.target.value)
                }} rows={6} style={{ width: '400px' }} placeholder='请粘贴入退回的数据，一行一条' />
            </Col>
        </Row>
        <p style={{ paddingTop: '10px' }}><Button onClick={subReturns}>提交</Button></p>
        <Card>
            <Row gutter={5}>
                <Col>
                    <SelectStatus value={filters.status} onChange={t => {
                        const _filters = { ...filters }
                        _filters.status = t
                        setFilters(_filters)
                    }} />
                </Col>
                <Col><DatePicker.RangePicker onChange={handleRange} /></Col>
                <Col><Input.Search allowClear onSearch={t=>{
                    const _fts = {...filters}
                    _fts.skey = t
                    setFilters(_fts)
                }} placeholder='请输入手机号' /></Col>
            </Row>
        </Card>
    </>

    const handleCheck = () => {
        req.post('/api/return',{action:'handleCheck',rids:selectedRowKeys}).then(r=>{
            console.log(r)
            
            if(r.status === 'done'){
                message.success(r.msg)
                setSelectedRowKeys([])
                getReturns()
            }else{
                message.error(r.msg)
            }
        })
    }

    const handleChanges = (pagination, filter, sorter) => {
        const pagr = { ...pagi }
        pagr.current = pagination.current
        pagr.pageSize = pagination.pageSize
        pagr.order = sorter.order
        pagr.field = sorter.field
        pagr.level = filter.level
        pagr.location = filter.location
        // console.log(pagr)
        setPagi(pagr)
    }

    const handleDel = () => {
        req.post('/api/return', { action: 'handleDel', rids: selectedRowKeys }).then(r => {
            console.log(r)
            if (r.status === 'done') {
                message.success('删除成功')
                getReturns()
            } else {
                message.error(r.msg)
            }
        })
    }

    const footer = () => <Row>
        <Col>选中项 : 
            <Popconfirm 
                title='确定审核选中项？'
                onConfirm={handleCheck}
                okText="是的"
                cancelText="否"
            >
                <Button type='primary'>退补</Button>
            </Popconfirm>
            <Popconfirm
                title='删除选中项？'
                onConfirm={handleDel}
                okText="是的"
                cancelText="否"
            >
                <Button danger>删除</Button>
            </Popconfirm>
        </Col>
    </Row>

    const columns = [
        { title: 'ID', dataIndex: 'id', key: 'id', sorter: true, defaultSortOrder: 'descend' },
        { title: '电话号码', dataIndex: 'phone', key: 'phone', width: 160, render: (text,item) => <DialPhone refresh={()=>getReturns()} item={item} phone={text} />},
        { title: '状态', dataIndex: 'status', key: 'status', },
        { title: '操作', dataIndex: 'actions', key: 'actions', render: (text, item) => <ModReturn refresh={()=>getReturns()} item={item} />},
        {
        title: '项目', dataIndex: 'project', key: 'project', render: (text, item) => {
           return <Button size='small' onDoubleClick={()=>{
               const _filters = {...filters}
               _filters.pid = item.pid
               setFilters(_filters)
           }} type='link'>{item.project}</Button>
        }},
        { title: '退返理由', dataIndex: 'reason', key: 'reason', },
        { title: '兴趣品牌', dataIndex: 'interest', key: 'interest', },
        { title: '创建者', dataIndex: 'creator', key: 'creator',},
        { title: '分配时间', dataIndex: 'sent_at', key: 'sent_at', },
        { title: '退返时间', dataIndex: 'created_at', key: 'created_at', },
        { title: '更新时间', dataIndex: 'updated_at', key: 'updated_at', sorter: true,},
        { title: '日志', width:300, dataIndex: 'logs', key: 'logs', render: text => {
            // <Tooltip title={text}>{text.substring(0, 235)}</Tooltip>
            return <List
                // split={false}
                bordered={false}
                size='small'
                dataSource={text.split('§§').reverse()}
                renderItem={item => <List.Item>{item}</List.Item>}
                pagination={(text.split('§§')).length > 3 ? {pageSize:3,size:'small',position:'top'} : false}
            />
        }},
    ]

    const rowSelection = {
        selectedRowKeys,
        onChange: selectedRowKeys => {
            console.log(selectedRowKeys)
            setSelectedRowKeys(selectedRowKeys)
        }
    }

    useEffect(()=>{
        getReturns()
    }, [filters.pid,filters.skey,filters.status,filters.range,pagi.current,pagi.order,pagi.field]) // eslint-disable-line

    return <Table
        bordered
        size='small'
        title={title}
        footer={footer}
        columns={columns}
        loading={loading}
        pagination={pagi}
        dataSource={returns}
        rowKey={record => record.id}
        rowSelection={rowSelection}
        onChange={handleChanges}
        showTotal={total => `总计 ${total} 条`}
    />
}

export default App